// import React from 'react';

import Icon from "./Icon";

import "./styles/style.scss";

export default Icon;
